$(window).on("load", function () {
  $(".loader").addClass("hidden");
  window.__everseatsYmmNavigatePending = false;
});

(function () {

  // Global capture-phase handler so modal CTAs always navigate,
  // even if other scripts bind bubble-phase click handlers.
  if (!window.__everseatsModalCtaBound) {
    window.__everseatsModalCtaBound = true;
    document.addEventListener(
      "click",
      (e) => {
        const anchor = e.target?.closest?.("a.btn-notComp, a.btn-allComp, a.btn-teslaComp");
        if (!anchor) return;

        e.preventDefault();
        // stopImmediatePropagation isn't available on all event types, but is on MouseEvent.
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        e.stopPropagation();

        const year = window.sessionStorage.getItem("user_year") || "";
        const make = window.sessionStorage.getItem("user_make") || "";
        const model = window.sessionStorage.getItem("user_model") || "";
        const trim = window.sessionStorage.getItem("user_trim") || "";

        let target = "";
        if (anchor.classList.contains("btn-notComp")) {
          target = "/pages/custom-quote";
        } else {
          // For the other CTAs, fall back to any URL stored on the submit link.
          target =
            document.querySelector(".garage-vehicle-button a")?.getAttribute("data-href") ||
            document.querySelector(".garage-vehicle-button a")?.getAttribute("href") ||
            "";
        }

        if (target && target.startsWith("/")) {
          const url = new URL(target, window.location.origin);
          if (year) url.searchParams.set("year", year);
          if (make) url.searchParams.set("make", make);
          if (model) url.searchParams.set("model", model);
          if (trim) url.searchParams.set("trim", trim);
          target = url.pathname + url.search;
        }

        if (!target) return;
        window.__everseatsYmmNavigatePending = true;
        $(".loader").removeClass("hidden");
        window.location.href = target;
      },
      true
    );
  }

  function everseatsHasYmmSelected() {
    const year = window.sessionStorage.getItem("user_year");
    const make = window.sessionStorage.getItem("user_make");
    const model = window.sessionStorage.getItem("user_model");
    const trim = window.sessionStorage.getItem("user_trim");
    if (isCustomSeatCoversProductPage()) {
      if (typeof window.everseatsHasValidCustomSeatCoversYmmt === "function") {
        return window.everseatsHasValidCustomSeatCoversYmmt();
      }
      // Custom seat covers require full valid EKR YMMT before unlocking variants.
      return Boolean(year && make && model && trim);
    }
    return Boolean(year && make && model);
  }

  function applyEverseatsVariantPickerGate() {
    if (!isCustomSeatCoversProductPage()) {
      document.documentElement.removeAttribute("data-ymm-gate-variants");
      document.documentElement.removeAttribute("data-ymm-selected");
      document
        .querySelectorAll("variant-radios.ymm-variant-picker--hidden, variant-selects.ymm-variant-picker--hidden")
        .forEach((el) => {
          el.classList.remove("ymm-variant-picker--hidden");
          el.removeAttribute("hidden");
        });
      return;
    }

    const selected = everseatsHasYmmSelected();
    document.documentElement.toggleAttribute("data-ymm-selected", selected);

    const sectionRoot =
      document.querySelector('[id^="MainProduct-"]') ||
      document.querySelector(".ProductWrapper") ||
      document.querySelector(".product__info-wrapper");

    const pickers = sectionRoot
      ? sectionRoot.querySelectorAll("variant-radios.no-js-hidden, variant-selects.no-js-hidden")
      : document.querySelectorAll("variant-radios.no-js-hidden, variant-selects.no-js-hidden");

    pickers.forEach((el) => {
      el.classList.toggle("ymm-variant-picker--hidden", !selected);
      if (!selected) el.setAttribute("hidden", "");
      else el.removeAttribute("hidden");
    });
  }

  window.applyEverseatsVariantPickerGate = applyEverseatsVariantPickerGate;

  const CUSTOM_SEAT_COVERS_PATH = /^\/products\/custom-seat-covers\/?$/;

  function isCustomSeatCoversProductPage() {
    return CUSTOM_SEAT_COVERS_PATH.test(window.location.pathname);
  }

  window.isCustomSeatCoversProductPage = isCustomSeatCoversProductPage;

  function isScsFirstContext() {
    if (isCustomSeatCoversProductPage()) return false;
    if (document.querySelector('.garage-modal-wrapper[data-ymm-selection-mode="scs-first"]')) return true;
    if (document.body.classList.contains("product")) return true;
    if (document.body.classList.contains("ymm-product-page")) return true;
    const path = window.location.pathname.replace(/\/$/, "") || "/";
    return path === "/";
  }

  function getYmmSelectionMode() {
    if (isCustomSeatCoversProductPage()) return "ekr-only";
    if (isScsFirstContext()) return "scs-first";
    return "all";
  }

  /** Every page except custom-seat-covers uses SCS-only YMM data. */
  function isScsOnlyGarageContext() {
    return !isCustomSeatCoversProductPage();
  }

  /** Surfaces that pick Year/Make/Model only (no trim UI). */
  function isYmmOnlyGarageContext() {
    return isScsOnlyGarageContext();
  }

  window.getYmmSelectionMode = getYmmSelectionMode;

  /** Trim stored in session but omitted from customer-facing YMM labels (e.g. generic "Base"). */
  function formatTrimForDisplay(trim) {
    const t = String(trim || "").trim();
    if (!t || t.toLowerCase() === "base") return "";
    return t;
  }

  window.everseatsFormatTrimForDisplay = formatTrimForDisplay;

  // ─── Checkbox tick ────────────────────────────────────────────────────────
  let boxes = document.querySelectorAll(".addons_list_item input[type=checkbox]");
  boxes.forEach(b => b.addEventListener("change", tick));
  function tick(e) {
    let state = e.target.checked;
    boxes.forEach(b => b.checked = false);
    e.target.checked = state;
  }

  // ─── Sliders & UI ─────────────────────────────────────────────────────────
  var featuredslider = function () {
    $(".flick-slide").flickity({ cellAlign: "left", wrapAround: true, pageDots: true, prevNextButtons: false });
    $(".flick-slide").on("change.flickity", function () { window.dispatchEvent(new Event("resize")); });
  };

  var featuredinfoslider = function () {
    $(".featured-info-slider-mobile").flickity({ cellAlign: "left", wrapAround: true, pageDots: true, prevNextButtons: false });
  };

  var trustpolioslider = function () {
    $('a[href="#shopify-section-template--16399091957853__newsletter_JXW7T9"]').click(function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: $("#shopify-section-template--16399091957853__newsletter_JXW7T9").offset().top }, 1000);
    });
    $(".trustpolio-slider").flickity({ cellAlign: "left", wrapAround: true, pageDots: true, prevNextButtons: false });
  };

  var instac = function () {
    $(".featured-insta-collage-one-parent.mobile").flickity({ cellAlign: "left", wrapAround: true, pageDots: true, prevNextButtons: false });
    document.addEventListener("click", function (e) {
      if (e.target.matches(".gallery_nav-btn.nav-btn-left")) {
        e.preventDefault();
        setTimeout(function () {
          var cur = document.querySelector(".thumbnail[aria-current]");
          var prev = cur?.parentElement.previousElementSibling?.querySelector(".thumbnail");
          if (prev) prev.dispatchEvent(new Event("click", { bubbles: true }));
        }, 500);
      }
    });
    document.addEventListener("click", function (e) {
      if (e.target.matches(".gallery_nav-btn.nav-btn-right")) {
        e.preventDefault();
        setTimeout(function () {
          var cur = document.querySelector(".thumbnail[aria-current]");
          var next = cur?.parentElement.nextElementSibling?.querySelector(".thumbnail");
          if (next) next.dispatchEvent(new Event("click", { bubbles: true }));
        }, 500);
      }
    });
  };

  var collectionSwatch = function () {
    $(document).on("click", ".collection_swatches a.swatch", function (e) {
      e.preventDefault();
      $(this).parent().find("a.swatch").removeClass("selected-swatch");
      $(this).addClass("selected-swatch");
      var variantImg = $(this).data("image");
      var url = $(this).attr("href");
      $(this).parents(".card__content").find(".card_product_link").attr("href", url);
      if ($(this).data("image").indexOf("no-image") == -1) {
        $(this).parents(".product-card-wrapper").find(".card__media .card-primary-image").attr("src", variantImg).attr("srcset", variantImg);
      }
    });
  };

  var stickyAddtoCart = function () {
    // Idempotent: re-running (e.g. shopify:section:load) shouldn't append a 2nd sticky bar.
    if (document.querySelector(".sticky-add-to-cart")) return;

    var addToCartButton = document.querySelector(".product-form__submit");
    var price = document.querySelector(".price.price--large");
    // Both must exist; otherwise a missing `price.innerHTML` would throw and abort the
    // rest of the window-load chain — including SeatSearch().
    if (addToCartButton && price) {
      var stickyButton = document.createElement("div");
      stickyButton.className = "sticky-add-to-cart";
      stickyButton.innerHTML = `<div class="sticky-content"><div class="sticky-price">${price.innerHTML}</div>${addToCartButton.outerHTML}</div><div class="stick-bar"><span></span></div>`;
      document.body.appendChild(stickyButton);
      window.addEventListener("scroll", function () {
        var rect = addToCartButton.getBoundingClientRect();
        stickyButton.style.display = (rect.top < window.innerHeight && rect.bottom > 0) ? "none" : "block";
      });
    }
    $(document).on("click", ".sticky-content .product-form__submit", function () {
      $(".product-form__buttons .product-form__submit").trigger("click");
    });
  };

  var variantBestValue = function () {};

  // ─── SeatSearch ───────────────────────────────────────────────────────────
  var SeatSearch = function () {

    const TESLA_MODELS = ["Model 3", "Model X", "Model S", "Model Y", "Cybertruck"];
    const TESLA_PRODUCT_URLS = {
      // Use relative URLs so local theme dev doesn't redirect to production.
      "Model 3":    "/products/tesla-model-3-covers",
      "Model X":    "/products/tesla-model-x-covers",
      "Model S":    "/products/tesla-model-s",
      "Model Y":    "/products/tesla-model-y-covers",
      "Cybertruck": "/products/cyber-covers",
    };

    // dom refs filled inside init()
    const dom = {};

    const isProductPage      = document.body.classList.contains("product");
    /** Page template with main-page-product (layout has no global `product`; ymm metafield page). */
    const isYmmProductPage   = document.body.classList.contains("ymm-product-page");
    const isTeslaProductPage = document.body.classList.contains("product_tesla");
    const isTeslaCollection  = document.body.classList.contains("tesla-product");

    const session = {
      get: (key)        => window.sessionStorage.getItem(key),
      set: (key, value) => window.sessionStorage.setItem(key, value),
      getVehicles: ()   => JSON.parse(sessionStorage.getItem("user_vehicles")) || {},
      setVehicles: (v)  => sessionStorage.setItem("user_vehicles", JSON.stringify(v)),
    };
    if (!session.get("user_vehicles")) session.set("user_vehicles", JSON.stringify({}));
    document.querySelector("a#HeaderMenu-shop")?.addEventListener("click", () => sessionStorage.clear());

    // ── Data helpers ────────────────────────────────────────────────────────
    function getManufacturerFilter() {
      if (isScsOnlyGarageContext()) {
        const wrapper = document.querySelector('.garage-modal-wrapper[data-ymm-manufacturer="SCS"]');
        return wrapper?.getAttribute("data-ymm-manufacturer") || "SCS";
      }
      if (getYmmSelectionMode() !== "ekr-only") return null;
      const wrapper =
        document.querySelector('.garage-modal-wrapper[data-ymm-manufacturer][data-ymm-product-handle="custom-seat-covers"]') ||
        document.querySelector('.product .garage-modal-wrapper[data-ymm-manufacturer]') ||
        document.querySelector('.garage-modal-wrapper[data-ymm-manufacturer]');
      return wrapper?.getAttribute("data-ymm-manufacturer") || "EKR";
    }

    function setSubmitHref(url) {
      if (dom.submitLink) dom.submitLink.setAttribute("href", url);
    }

    function navigateTo(url) {
      window.__everseatsYmmNavigatePending = true;
      $(".loader").removeClass("hidden");
      setTimeout(() => {
        window.location.href = url;
      }, 50);
    }

    function buildCustomQuoteUrl(year, make, model, trim) {
      return `/pages/custom-quote?year=${encodeURIComponent(year)}&make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}&trim=${encodeURIComponent(trim || "")}`;
    }

    function redirectToCustomQuote(year, make, model, trim) {
      const quoteUrl = buildCustomQuoteUrl(year, make, model, trim);
      setSubmitHref(quoteUrl);
      navigateTo(quoteUrl);
    }

    function isVehicleLeaf(entry) {
      return Boolean(entry && entry.Warning !== undefined);
    }

    function isNotCompatible(entry) {
      if (!entry || !entry.Compatible) return true;
      return entry.Compatible.replace(/\s/g, "") === "NotCompatible";
    }

    function getTrimLeaves(entry) {
      if (!entry || isVehicleLeaf(entry)) return [];
      return Object.keys(entry).filter((key) => isVehicleLeaf(entry[key]));
    }

    function getScsTrims(entry) {
      return getTrimLeaves(entry).filter((trim) => entry[trim].Manufacturer === "SCS");
    }

    function getEkrTrims(entry) {
      return getTrimLeaves(entry).filter((trim) => {
        const leaf = entry[trim];
        return leaf.Manufacturer === "EKR" && !isNotCompatible(leaf);
      });
    }

    function modelHasCompatibleScs(entry) {
      if (!entry) return false;
      if (isVehicleLeaf(entry)) return entry.Manufacturer === "SCS" && !isNotCompatible(entry);
      return getScsTrims(entry).some((trim) => !isNotCompatible(entry[trim]));
    }

    function modelHasCompatibleEkr(entry) {
      if (!entry) return false;
      if (isVehicleLeaf(entry)) return entry.Manufacturer === "EKR" && !isNotCompatible(entry);
      return getEkrTrims(entry).length > 0;
    }

    /** SCS-first picker: show model when compatible SCS exists, or EKR when SCS is unavailable. */
    function shouldShowModelInScsFirstContext(entry) {
      return modelHasCompatibleScs(entry) || modelHasCompatibleEkr(entry);
    }

    function vehicleExistsInScsFirstSession(year, make, model, trim) {
      const entry = getRawMergedModels(year, make)[model];
      if (!entry) return false;

      if (trim) {
        const leaf = isVehicleLeaf(entry) ? entry : entry[trim];
        return Boolean(leaf && isVehicleLeaf(leaf) && !isNotCompatible(leaf));
      }

      const compatibleScsTrims = getScsTrims(entry).filter((t) => !isNotCompatible(entry[t]));
      if (compatibleScsTrims.length === 1) return true;

      if (isVehicleLeaf(entry)) {
        return entry.Manufacturer === "SCS" && !isNotCompatible(entry);
      }

      const ekrTrims = getEkrTrims(entry);
      if (compatibleScsTrims.length === 0 && ekrTrims.length === 1) return true;
      return false;
    }

    let scsFirstPickerModelCache = null;
    function getScsFirstPickerModel() {
      if (scsFirstPickerModelCache) return scsFirstPickerModelCache;
      scsFirstPickerModelCache = {};
      Object.keys(window.model || {}).forEach((year) => {
        Object.keys(window.model[year] || {}).forEach((make) => {
          Object.keys(window.model[year][make] || {}).forEach((model) => {
            const entry = window.model[year][make][model];
            if (!shouldShowModelInScsFirstContext(entry)) return;
            if (!scsFirstPickerModelCache[year]) scsFirstPickerModelCache[year] = {};
            if (!scsFirstPickerModelCache[year][make]) scsFirstPickerModelCache[year][make] = {};
            scsFirstPickerModelCache[year][make][model] = entry;
          });
        });
      });
      return scsFirstPickerModelCache;
    }

    function getPickerModel() {
      return isScsOnlyGarageContext() ? getScsFirstPickerModel() : getActiveModel();
    }

    function getRawMergedModels(year, canonicalMake) {
      const merged = {};
      Object.keys(window.model[year] || {})
        .filter((k) => k.toLowerCase() === canonicalMake.toLowerCase())
        .forEach((key) => Object.assign(merged, window.model[year][key]));
      return merged;
    }

    function resetEkrFallbackState() {
      window.__everseatsEkrFallback = false;
      sessionStorage.removeItem("user_ekr_fallback");
      if (dom.trimContainer) dom.trimContainer.style.display = "none";
    }

    function beginEkrFallback(year, make, model) {
      const entry = getRawMergedModels(year, make)[model];
      const quoteUrl = buildCustomQuoteUrl(year, make, model, "");

      if (!entry) {
        setSubmitHref(quoteUrl);
        navigateTo(quoteUrl);
        return;
      }

      if (isVehicleLeaf(entry) && entry.Manufacturer === "EKR") {
        if (isNotCompatible(entry)) {
          setSubmitHref(quoteUrl);
          navigateTo(quoteUrl);
          return;
        }
        applyVehicleData(year, make, model, "", entry);
        return;
      }

      const ekrTrims = getEkrTrims(entry);
      if (ekrTrims.length === 0) {
        setSubmitHref(quoteUrl);
        navigateTo(quoteUrl);
        return;
      }

      if (ekrTrims.length === 1) {
        const trim = ekrTrims[0];
        applyVehicleData(year, make, model, trim, entry[trim]);
        return;
      }

      window.__everseatsEkrFallback = true;
      sessionStorage.setItem("user_ekr_fallback", "1");
      resetDropdown(dom.trimInput, "Select Trim");
      ekrTrims.sort().forEach((trim) => {
        const opt = document.createElement("option");
        opt.value = trim;
        opt.innerHTML = trim;
        dom.trimInput.appendChild(opt);
      });
      dom.trimContainer.style.display = "";
      dom.trimInput.removeAttribute("disabled");
      session.set("user_year", year);
      session.set("user_make", make);
      session.set("user_model", model);
      session.set("user_trim", "");
    }

    function resolveScsFirstVehicle(year, make, model) {
      resetEkrFallbackState();
      const entry = getRawMergedModels(year, make)[model];

      const onNoScsPath = () => {
        beginEkrFallback(year, make, model);
      };

      if (!entry) {
        redirectToCustomQuote(year, make, model, "");
        return;
      }

      if (isVehicleLeaf(entry)) {
        if (entry.Manufacturer === "SCS") {
          if (isNotCompatible(entry)) onNoScsPath();
          else applyVehicleData(year, make, model, "", entry);
        } else {
          onNoScsPath();
        }
        return;
      }

      const scsTrims = getScsTrims(entry);
      if (scsTrims.length === 1) {
        const trim = scsTrims[0];
        const leaf = entry[trim];
        if (isNotCompatible(leaf)) onNoScsPath();
        else applyVehicleData(year, make, model, trim, leaf);
        return;
      }

      onNoScsPath();
    }

    function vehicleExistsInScsFirstContext(year, make, model, trim) {
      const entry = getRawMergedModels(year, make)[model];
      if (!entry) return false;
      if (trim) {
        const trimNode = entry[trim];
        return Boolean(trimNode && isVehicleLeaf(trimNode));
      }
      return true;
    }

    function filterVehicleSubtree(node, manufacturer) {
      if (!node || !manufacturer) return node;
      if (node.Warning !== undefined) {
        return node.Manufacturer === manufacturer ? node : null;
      }
      const out = {};
      Object.keys(node).forEach((key) => {
        const child = filterVehicleSubtree(node[key], manufacturer);
        if (
          child &&
          (child.Warning !== undefined || Object.keys(child).length > 0)
        ) {
          out[key] = child;
        }
      });
      return Object.keys(out).length ? out : null;
    }

    let activeModelCache = null;
    let activeModelCacheKey = null;
    function getActiveModel() {
      const manufacturer = getManufacturerFilter();
      const cacheKey = manufacturer || "__all__";
      if (activeModelCache && activeModelCacheKey === cacheKey) return activeModelCache;
      activeModelCacheKey = cacheKey;
      if (!manufacturer) {
        activeModelCache = window.model;
        return activeModelCache;
      }
      activeModelCache = {};
      Object.keys(window.model || {}).forEach((year) => {
        const yearData = filterVehicleSubtree(window.model[year], manufacturer);
        if (yearData && Object.keys(yearData).length) {
          activeModelCache[year] = yearData;
        }
      });
      return activeModelCache;
    }

    function getMergedModels(year, canonicalMake) {
      const merged = {};
      Object.keys(getActiveModel()[year] || {})
        .filter(k => k.toLowerCase() === canonicalMake.toLowerCase())
        .forEach(key => Object.assign(merged, getActiveModel()[year][key]));
      return merged;
    }

    function vehicleExistsInActiveModel(year, make, model, trim) {
      const manufacturer = getManufacturerFilter();
      if (!manufacturer) return true;
      const merged = getMergedModels(year, make);
      const node = merged[model];
      if (!node) return false;
      if (node.Warning !== undefined) return node.Manufacturer === manufacturer;
      if (!trim) {
        if (manufacturer === "EKR") {
          const ekrTrims = getEkrTrims(node);
          if (ekrTrims.length === 1) return true;
        }
        if (manufacturer === "SCS") {
          const scsTrims = getScsTrims(node);
          if (scsTrims.length === 1) return true;
        }
        return false;
      }
      const trimNode = node[trim];
      return Boolean(trimNode && trimNode.Manufacturer === manufacturer);
    }

    function hydrateYmmFromUrlParams() {
      const params = new URLSearchParams(window.location.search);
      [["year", "user_year"], ["make", "user_make"], ["model", "user_model"], ["trim", "user_trim"]].forEach(
        ([param, key]) => {
          const value = params.get(param);
          if (value) session.set(key, value);
        }
      );
      const compatParam = params.get("compat");
      if (compatParam && !session.get("user_compat")) {
        session.set("user_compat", compatParam.replace(/\+/g, " "));
      }
    }

    function autoResolveEkrTrimIfNeeded() {
      if (getYmmSelectionMode() !== "ekr-only") return;
      const year = session.get("user_year");
      const make = session.get("user_make");
      const model = session.get("user_model");
      if (!year || !make || !model || session.get("user_trim")) return;

      const entry = getRawMergedModels(year, make)[model];
      if (!entry) return;

      if (isVehicleLeaf(entry) && entry.Manufacturer === "EKR" && !isNotCompatible(entry)) {
        session.set("user_compat", entry.Compatible);
        session.set("user_warning", entry.Warning);
        return;
      }

      const ekrTrims = getEkrTrims(entry);
      if (ekrTrims.length === 1) {
        const trim = ekrTrims[0];
        const leaf = entry[trim];
        session.set("user_trim", trim);
        session.set("user_compat", leaf.Compatible);
        session.set("user_warning", leaf.Warning);
      }
    }

    function syncVehicleDisplayFromSession() {
      if (!isCustomSeatCoversProductPage()) return;
      const year = session.get("user_year");
      const make = session.get("user_make");
      const model = session.get("user_model");
      const trim = session.get("user_trim") || "";
      if (!year || !make || !model || !trim) return;
      if (!vehicleExistsInActiveModel(year, make, model, trim)) return;
      document.querySelectorAll(".coll_make").forEach((el) => { el.innerHTML = make; });
      document.querySelectorAll(".modal_1").forEach((el) => { el.innerHTML = model; });
      document.querySelectorAll(".years").forEach((el) => { el.innerHTML = year; });
      document.querySelectorAll(".trim").forEach((el) => {
        el.innerHTML = formatTrimForDisplay(trim);
      });
      const garageInner = document.querySelector(".garage-modal-inner");
      const garageSelected = document.querySelector(".garage-selected-vehicle");
      if (garageInner) garageInner.style.display = "none";
      if (garageSelected) garageSelected.style.display = "flex";
    }

    function clearYmmSessionIfFilteredOut() {
      const mode = getYmmSelectionMode();
      const year = session.get("user_year");
      const make = session.get("user_make");
      const model = session.get("user_model");
      const trim = session.get("user_trim") || "";
      if (!year || !make || !model) return;

      let valid = true;
      if (mode === "ekr-only") {
        valid = vehicleExistsInActiveModel(year, make, model, trim);
      } else if (mode === "scs-first") {
        valid = isScsOnlyGarageContext()
          ? vehicleExistsInScsFirstSession(year, make, model, trim)
          : vehicleExistsInScsFirstContext(year, make, model, trim);
      } else {
        return;
      }

      if (valid) return;

      if (mode === "ekr-only") {
        const ekrEntry = getMergedModels(year, make)[model];
        if (ekrEntry) {
          ["user_trim", "user_compat", "user_warning", "user_ekr_fallback"].forEach((key) =>
            sessionStorage.removeItem(key)
          );
          if (typeof window.applyEverseatsYmmProductChrome === "function") {
            window.applyEverseatsYmmProductChrome();
          }
          applyEverseatsVariantPickerGate();
          return;
        }
      }

      ["user_year", "user_make", "user_model", "user_trim", "user_compat", "user_warning", "user_ekr_fallback"].forEach(
        (key) => sessionStorage.removeItem(key)
      );
      if (typeof window.applyEverseatsYmmProductChrome === "function") {
        window.applyEverseatsYmmProductChrome();
      }
      applyEverseatsVariantPickerGate();
    }

    // ── Garage ──────────────────────────────────────────────────────────────
    function buildVehicleId(year, make, model, trim) {
      const esc = s => (s || "").replaceAll(" ", "_SPACE_");
      return [esc(year), esc(make), esc(model), esc(trim)].join("_GAP_");
    }
    function parseVehicleId(id) {
      const [year, make, model, trim] = id.split("_GAP_").map(s => s.replaceAll("_SPACE_", " "));
      return { year, make, model, trim: trim || "" };
    }

    function renderGarageVehicles() {
      const vehicles = session.getVehicles();
      const count = Object.keys(vehicles).length;
      dom.vehicleCount.innerHTML = count === 1 ? "1 vehicle found" : `${count} vehicles found`;
      Object.values(vehicles).forEach(addVehicleElement);
    }

    function addVehicleElement(carData) {
      const id = buildVehicleId(carData.year, carData.make, carData.model, carData.trim);
      const container = document.createElement("div");
      container.classList.add("garage-vehicle");
      container.setAttribute("id", id);
      container.addEventListener("click", onVehicleSelect);

      const nameLabel = document.createElement("span");
      nameLabel.classList.add("garage-vehicle-name");
      nameLabel.setAttribute("id", id);
      nameLabel.innerHTML = `${carData.year} ${carData.make} ${carData.model}${formatTrimForDisplay(carData.trim) ? " " + formatTrimForDisplay(carData.trim) : ""}`;

      const selectedBadge = document.createElement("div");
      selectedBadge.classList.add("garage-selected");
      selectedBadge.setAttribute("id", id);
      if (carData.selected) selectedBadge.classList.add("vehicle-selected");

      const selectedLabel = document.createElement("span");
      selectedLabel.innerHTML = "SELECTED";
      selectedLabel.setAttribute("id", id);

      selectedBadge.appendChild(selectedLabel);
      container.appendChild(nameLabel);
      container.appendChild(selectedBadge);
      dom.vehicleList.appendChild(container);
    }

    function onVehicleSelect(e) {
      const selectedId = e.target.getAttribute("id");
      const vehicles = session.getVehicles();
      document.querySelectorAll(".garage-vehicle").forEach(el => el.querySelector(".garage-selected").classList.remove("vehicle-selected"));
      document.querySelector(`.garage-vehicle#${selectedId}`)?.querySelector(".garage-selected")?.classList.add("vehicle-selected");
      const { year, make, model, trim } = parseVehicleId(selectedId);
      session.set("user_year",    year);
      session.set("user_make",    make);
      session.set("user_model",   model);
      session.set("user_trim",    trim);
      session.set("user_compat",  vehicles[selectedId]?.compatible);
      session.set("user_warning", vehicles[selectedId]?.warning);
      Object.keys(vehicles).forEach(id => (vehicles[id].selected = false));
      vehicles[selectedId].selected = true;
      session.setVehicles(vehicles);
      $(".loader").removeClass("hidden");
      location.reload();
    }

    // ── Dropdown helpers ────────────────────────────────────────────────────
    function resetDropdown(el, placeholder) {
      el.innerHTML = `<option value="">${placeholder}</option>`;
      el.classList.add("not-ready");
    }

    function enableDropdown(el) {
      el.classList.remove("not-ready");
    }

    function populateYearDropdown() {
      Object.keys(getPickerModel()).sort((a, b) => b - a).forEach(year => {
        const opt = document.createElement("option");
        opt.value = year; opt.innerHTML = year;
        dom.yearInput.appendChild(opt);
      });
    }

    // ── Change handlers ─────────────────────────────────────────────────────
    function onYearChange(e) {
      const selectedYear = e.target.value;
      resetEkrFallbackState();
      resetDropdown(dom.makeInput,  "Select Make");
      resetDropdown(dom.modelInput, "Select Model");
      resetDropdown(dom.trimInput,  "Select Trim");
      dom.trimContainer.style.display = "none";
      dom.submitButton.setAttribute("disabled", "true");
      if (!selectedYear) return;

      const seen = {};
      Object.keys(getPickerModel()[selectedYear] || {}).forEach(make => {
        const key = make.toLowerCase();
        if (!seen[key] || make[0] === make[0].toUpperCase()) seen[key] = make;
      });
      Object.values(seen).sort().forEach(make => {
        const opt = document.createElement("option");
        opt.value = make; opt.innerHTML = make;
        dom.makeInput.appendChild(opt);
      });
      enableDropdown(dom.makeInput);
    }

    function onMakeChange(e) {
      const selectedMake = e.target.value;
      resetEkrFallbackState();
      resetDropdown(dom.modelInput, "Select Model");
      resetDropdown(dom.trimInput,  "Select Trim");
      dom.trimContainer.style.display = "none";
      dom.submitButton.setAttribute("disabled", "true");
      if (!selectedMake) return;

      const year = dom.yearInput.value;
      const modelSource = isScsOnlyGarageContext()
        ? getRawMergedModels(year, selectedMake)
        : getMergedModels(year, selectedMake);
      Object.keys(modelSource)
        .filter((model) =>
          isScsOnlyGarageContext()
            ? shouldShowModelInScsFirstContext(modelSource[model])
            : true
        )
        .sort()
        .forEach(model => {
        const opt = document.createElement("option");
        opt.value = model; opt.innerHTML = model;
        dom.modelInput.appendChild(opt);
      });
      enableDropdown(dom.modelInput);
    }

    function onModelChange(e) {
      const selectedModel = e.target.value;
      resetDropdown(dom.trimInput, "Select Trim");
      dom.submitButton.setAttribute("disabled", "true");
      if (!selectedModel) return;

      const year = dom.yearInput.value;
      const make = dom.makeInput.value;

      if (isScsOnlyGarageContext()) {
        dom.trimContainer.style.display = "none";
        dom.trimInput.setAttribute("disabled", "true");
        if (!window.__everseatsYmmEditRestore) {
          resolveScsFirstVehicle(year, make, selectedModel);
        }
        return;
      }

      const entry = getMergedModels(year, make)[selectedModel];
      if (entry?.Warning !== undefined) {
        // No trims — hide trim container and resolve immediately
        dom.trimContainer.style.display = "none";
        dom.trimInput.setAttribute("disabled", "true");
        if (!isYmmEditInteractive()) {
          applyVehicleData(year, make, selectedModel, "", entry);
        }
      } else {
        // Has trims — show trim container and populate
        Object.keys(entry || {}).sort().forEach(trim => {
          const opt = document.createElement("option");
          opt.value = trim; opt.innerHTML = trim;
          dom.trimInput.appendChild(opt);
        });
        dom.trimContainer.style.display = "";
        dom.trimInput.removeAttribute("disabled");
      }
    }

    function onTrimChange(e) {
      const selectedTrim = e.target.value;
      dom.submitButton.setAttribute("disabled", "true");
      if (!selectedTrim) return;

      const year = dom.yearInput.value;
      const make = dom.makeInput.value;
      const model = dom.modelInput.value;

      if (window.__everseatsEkrFallback) {
        const entry = getRawMergedModels(year, make)[model]?.[selectedTrim];
        if (!entry || entry.Manufacturer !== "EKR" || isNotCompatible(entry)) return;
        window.__everseatsEkrFallback = false;
        sessionStorage.removeItem("user_ekr_fallback");
        applyVehicleData(year, make, model, selectedTrim, entry);
        return;
      }

      const entry = getMergedModels(year, make)[model]?.[selectedTrim];
      applyVehicleData(year, make, model, selectedTrim, entry || {});
    }

    function isYmmEditInteractive() {
      return window.__everseatsYmmEditOpen === true || window.__everseatsYmmEditRestore === true;
    }

    function applyVehicleData(year, make, model, trim, vehicleData) {
      const compat    = vehicleData.Compatible || "";
      const compatKey = compat.replace(/\s/g, "");
      session.set("user_year",    year);
      session.set("user_make",    make);
      session.set("user_model",   model);
      session.set("user_trim",    trim);
      session.set("user_compat",  compat);
      session.set("user_warning", vehicleData.Warning);
      sessionStorage.removeItem("user_ekr_fallback");
      window.__everseatsEkrFallback = false;
      if (!window.__everseatsYmmEditRestore) {
        window.__everseatsYmmEditOpen = false;
      }
      dom.submitButton.removeAttribute("disabled");
      // Edit modal prefill / open picker — do not navigate or re-sync page chrome.
      if (isYmmEditInteractive()) {
        if (typeof window.applyEverseatsYmmProductChrome === "function") {
          window.applyEverseatsYmmProductChrome();
        }
        applyEverseatsVariantPickerGate();
        return;
      }
      resolveSubmitAction({ year, make, model, trim, compat, compatKey });
      if (typeof window.applyEverseatsYmmProductChrome === "function") {
        window.applyEverseatsYmmProductChrome();
      }
      applyEverseatsVariantPickerGate();
    }

    // ── Submit / redirect ───────────────────────────────────────────────────
    function resolveSubmitAction({ year, make, model, trim, compat, compatKey }) {
      if (isYmmEditInteractive()) return;
      const teslaModel    = TESLA_MODELS.find(t => model.includes(t));
      const collectionUrl = `/collections/all?year=${year}&make=${make}&model=${model}&trim=${trim}&compat=${compatKey}`;
      const CUSTOM_SEAT_COVERS_COMPAT_TOKENS = [
        "FirstRow+SecondRow+ThirdRow",
        "FrontRow+SecondRow+ThirdRow",
        "FirstRow&SecondRow",
        "Front&SecondRows",
        "FirstRow",
        "FrontRow",
        "SecondRow",
        "ThirdRow",
        "Driver'sSeat",
        "DriverSeat",
      ];
      /** Row-style compat (single or comma-separated) → /products/custom-seat-covers. */
      function isCustomSeatCoversCompat(key) {
        if (!key) return false;
        const k = String(key).replace(/\s/g, "");
        if (!k || k === "NotCompatible") return false;
        return CUSTOM_SEAT_COVERS_COMPAT_TOKENS.some((token) => k.includes(token));
      }
      const customProductPath = "/products/custom-seat-covers";
      const customProductUrl  = `${customProductPath}?year=${year}&make=${make}&model=${model}&trim=${trim}&compat=${compatKey}`;
      const collectionsAllPath = "/collections/all";
      const customQuotePath = "/pages/custom-quote";
      const customQuoteUrl =
        `${customQuotePath}?year=${encodeURIComponent(year)}&make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}&trim=${encodeURIComponent(trim || "")}`;
      function redirectTo(url) {
        window.__everseatsYmmNavigatePending = true;
        $(".loader").removeClass("hidden");
        setTimeout(() => {
          window.location.href = url;
        }, 50);
      }

      if (isTeslaProductPage) {
        if (compatKey === "NotCompatible") { setSubmitHref(customQuoteUrl); redirectTo(customQuoteUrl); }
        else if (teslaModel) { setSubmitHref(`${TESLA_PRODUCT_URLS[teslaModel]}?year=${year}&make=${make}&model=${model}&trim=${trim}&compat=${compat}`); triggerSubmitWithDelay(); }
        else if (isTeslaCollection) { showModal("wrongCollection", { year, make, model, href: collectionUrl }); }
        else { setSubmitHref(collectionUrl); triggerSubmitWithDelay(); }

      } else if (isProductPage || isYmmProductPage) {
        if (compatKey === "NotCompatible") { setSubmitHref(customQuoteUrl); redirectTo(customQuoteUrl); }
        else if (teslaModel) { showModal("teslaCollection", { year, make, model }); }
        else if (isTeslaCollection) { showModal("wrongCollection", { year, make, model, href: collectionUrl }); }
        else {
          const userCompat = window.sessionStorage.getItem("user_compat") || "";
          const compatLower = userCompat.toLowerCase();

          // Split the string into individual values and trim whitespace
          const compatParts = compatLower.split(",").map(s => s.trim());

          // Check if ANY part exactly matches a "compatible" value
          const compatExact = ["full seat", "front row", "back row", "front", "back"];
          const isCompat = compatParts.some(part => compatExact.includes(part));

          let productPath = window.location.pathname.replace(/\/$/, "");
          const onCustomSeatCoversPdp = productPath.includes(customProductPath);

          // if (isNC) {
          //   // NC takes priority — append -nc if not already present
          //   if (!productPath.endsWith("-nc")) {
          //     productPath = productPath + "-nc";
          //   }
          // } else if (isCompat) {
          //   // Strip -nc suffix if present
          //   productPath = productPath.replace(/-nc$/, "");
          // }
          
        if (isCustomSeatCoversCompat(compatKey)) {
          productPath = customProductPath;
        } else if (isCompat && onCustomSeatCoversPdp) {
          // On custom-seat-covers, never redirect away; just unlock the page UI.
          productPath = customProductPath;
        } else if (isYmmProductPage && window.ymmPageConfig && window.ymmPageConfig.productHandle) {
          // Line-specific YMM *pages* must navigate to /pages/{year}-{make}-{model}-{trim}-{productHandle}
          // (see snippets/product-mmy-filter.liquid window.ymmPageConfig). Using the current pathname
          // only reloads the same slug so the UI reverts to the page's baked-in vehicle.
          const ph = String(window.ymmPageConfig.productHandle).replace(/^\/+|\/+$/g, "");
          if (ph === "custom-seat-covers") {
            productPath = isCustomSeatCoversCompat(compatKey)
              ? customProductPath
              : collectionsAllPath;
          } else {
            const base = String(window.ymmPageConfig.pagesBasePath || "/pages/").replace(/\/*$/, "/");
            const seg = (s) =>
              String(s || "")
                .toLowerCase()
                .trim()
                .replace(/['\u2019]/g, "")
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-+/g, "-")
                .replace(/^-+|-+$/g, "");
            const parts = [year, make, model, trim].map(seg).filter(Boolean);
            if (parts.length) productPath = `${base}${parts.join("-")}-${ph}`.replace(/\/+/g, "/").replace(/\/$/, "");
          }
        }

          const finalUrl =
            productPath === customProductPath
              ? customProductUrl
              : productPath === collectionsAllPath
              ? collectionUrl
              : `${productPath}?year=${year}&make=${make}&model=${model}&trim=${trim}&compat=${compatKey}`;
          if (productPath === collectionsAllPath) {
            window.sessionStorage.setItem("everseats_ymm_collection_pick", "1");
          }
          setSubmitHref(finalUrl);
          window.__everseatsYmmNavigatePending = true;
          $(".loader").removeClass("hidden");
          setTimeout(() => {
            $("#garage-vehicle-submit-button").trigger("click");
            window.location.href = finalUrl;
          }, 500);
        }

      } else {
        // if (compatKey === "NotCompatible") { setSubmitHref(collectionUrl); }
        if (compatKey === "NotCompatible") { setSubmitHref("/pages/custom-quote"); }
        else if (teslaModel) { setSubmitHref(`${TESLA_PRODUCT_URLS[teslaModel]}?year=${year}&make=${make}&model=${model}&trim=${trim}&compat=${compatKey}`); }
        else if (isCustomSeatCoversCompat(compatKey)) { setSubmitHref(customProductUrl); }
        else { setSubmitHref(collectionUrl); }
      }
    }

    function triggerSubmitWithDelay() {
      window.__everseatsYmmNavigatePending = true;
      $(".loader").removeClass("hidden");
      setTimeout(() => {
        $("#garage-vehicle-submit-button").trigger("click");
      }, 500);
    }

    // ── Modal ───────────────────────────────────────────────────────────────
    const MODAL_MESSAGES = {
      notCompatible:   () => `is not compatible with our seat covers at this time. But no worries, our expert design team will work with you to get one made via a <a class='btn-notComp' href='#'>Custom Quote</a>! To make up for it we'll throw in an additional 10% off your purchase!`,
      teslaCollection: () => `is not exclusive to this collection. If you are looking for the <span class='years'></span> <span class='coll_make'></span> <span class='modal_1'></span> seat covers please visit the <a class='btn-teslaComp' href='#'>Tesla Collection Page</a> or`,
      wrongCollection: () => `This seat cover is exclusive to only Tesla models. If you are looking for the <span class='years'></span> <span class='coll_make'></span> <span class='modal_1'></span> seat covers please visit the <a class='btn-allComp' href='#'>Collection Page</a> or`,
    };

    function showModal(type, { year, make, model, href } = {}) {
      const $overlay = $(".garage-modal-overlay");
      document.body.classList.remove("garage-modal-open");
      if (href) dom.submitLink.setAttribute("data-href", href);
      if (type === "notCompatible") dom.submitLink.setAttribute("data-href", "/pages/custom-quote");
      if (type === "teslaCollection") dom.submitLink.setAttribute("data-href", "https://everseats.com/collections/tesla-collection");
      $overlay.find(".years, .coll_make, .modal_1,. trim").remove();
      dom.modalText.innerHTML = MODAL_MESSAGES[type]();
      $overlay.find(".years").html(year);
      $overlay.find(".coll_make").html(make);
      $overlay.find(".modal_1").html(model);
      $overlay.find(".trim").html(model);
      dom.modalOuter.style.display   = "none";
      dom.modalOverlay.style.display = "flex";
    }

    // ── Submit click ────────────────────────────────────────────────────────
    function onSubmitClick(e) {
      const year  = dom.yearInput.value;
      const make  = dom.makeInput.value;
      const model = dom.modelInput.value;
      const trim  = dom.trimInput?.value || session.get("user_trim") || "";
      const compat = session.get("user_compat");
      const wasEditOpen = window.__everseatsYmmEditOpen === true;

      session.set("user_year",  year);
      session.set("user_make",  make);
      session.set("user_model", model);
      session.set("user_trim",  trim);
      const vehicles = session.getVehicles();
      const newId    = buildVehicleId(year, make, model, trim);
      Object.keys(vehicles).forEach(id => (vehicles[id].selected = false));
      vehicles[newId] = { year, make, model, trim, compat, selected: true };
      session.setVehicles(vehicles);

      const submitHref =
        dom.submitLink?.getAttribute("href") ||
        dom.submitLink?.getAttribute("data-href") ||
        "";

      if (wasEditOpen) {
        e?.preventDefault?.();
        window.__everseatsYmmEditOpen = false;
        const compatKey = (compat || "").replace(/\s/g, "");
        resolveSubmitAction({ year, make, model, trim, compat, compatKey });
        if (typeof window.applyEverseatsYmmProductChrome === "function") {
          window.applyEverseatsYmmProductChrome();
        }
        applyEverseatsVariantPickerGate();
        return;
      }

      if (submitHref && submitHref !== "#" && !submitHref.startsWith("javascript:")) {
        e?.preventDefault?.();
        if (submitHref.includes("/collections/all")) {
          window.sessionStorage.setItem("everseats_ymm_collection_pick", "1");
        }
        localStorage.setItem("HomeSearch", true);
        window.__everseatsYmmNavigatePending = true;
        $(".loader").removeClass("hidden");
        window.location.href = submitHref;
        applyEverseatsVariantPickerGate();
        return;
      }

      applyEverseatsVariantPickerGate();
    }

    // ── Init ────────────────────────────────────────────────────────────────
    // Called from $(window).on("load") so window.model is guaranteed loaded
    dom.yearInput    = document.getElementById("garage-year-input");
    dom.makeInput    = document.getElementById("garage-make-input");
    dom.modelInput   = document.getElementById("garage-model-input");
    dom.trimInput     = document.getElementById("garage-trim-input");
    dom.trimContainer = document.getElementById("trim-input-container");
    dom.submitButton = document.getElementById("garage-vehicle-submit-button");
    dom.submitLink   = document.querySelector(".garage-vehicle-button a");
    dom.vehicleList  = document.querySelector(".garage-vehicles");
    dom.vehicleCount = document.getElementById("garage-vehicle-count");
    dom.modalOuter   = document.querySelector(".garage-modal-outer");
    dom.modalOverlay = document.querySelector(".garage-modal-overlay");
    dom.modalText    = document.querySelector(".garage-modal-overlay_txt");

    if (!dom.yearInput) {
      console.warn("SeatSearch: #garage-year-input not found in DOM.");
      return;
    }
    const activeModel = getPickerModel();
    if (!activeModel || !Object.keys(activeModel).length) {
      console.warn("SeatSearch: vehicle model data is empty.");
      return;
    }

    dom.yearInput.addEventListener("change",  onYearChange);
    dom.makeInput.addEventListener("change",  onMakeChange);
    dom.modelInput.addEventListener("change", onModelChange);
    dom.trimInput?.addEventListener("change", onTrimChange);
    const garageSubmit = document.querySelector(".garage-vehicle-button");
    if (garageSubmit) {
      garageSubmit.addEventListener("click", (e) => {
        if (!e.target.closest("#garage-vehicle-submit-button")) return;
        if (dom.submitButton?.hasAttribute("disabled")) return;
        onSubmitClick(e);
      });
    }
    dom.modalOverlay?.addEventListener("click", (e) => {
      const anchor = e.target?.closest?.("a.btn-notComp, a.btn-allComp, a.btn-teslaComp");
      if (!anchor) return;
      e.preventDefault();
      e.stopPropagation();

      const year  = session.get("user_year")  || dom.yearInput?.value || "";
      const make  = session.get("user_make")  || dom.makeInput?.value || "";
      const model = session.get("user_model") || dom.modelInput?.value || "";
      const trim  = session.get("user_trim")  || dom.trimInput?.value || "";

      // Preserve selected vehicle so custom-quote and downstream flows can read it.
      session.set("user_year",  year);
      session.set("user_make",  make);
      session.set("user_model", model);
      session.set("user_trim",  trim);

      let target = dom.submitLink?.getAttribute("data-href") || "";
      if (anchor.classList.contains("btn-notComp")) {
        target = "/pages/custom-quote";
      }

      // Append YMMT so the quote page can prefill.
      if (target && target.startsWith("/")) {
        const url = new URL(target, window.location.origin);
        if (year)  url.searchParams.set("year", year);
        if (make)  url.searchParams.set("make", make);
        if (model) url.searchParams.set("model", model);
        if (trim)  url.searchParams.set("trim", trim);
        target = url.pathname + url.search;
      }

      if (!target) return;
      window.__everseatsYmmNavigatePending = true;
      $(".loader").removeClass("hidden");
      window.location.href = target;
    });

    dom.makeInput.classList.add('not-ready');
    dom.modelInput.classList.add('not-ready');
    hydrateYmmFromUrlParams();
    autoResolveEkrTrimIfNeeded();
    clearYmmSessionIfFilteredOut();
    syncVehicleDisplayFromSession();
    populateYearDropdown();
    renderGarageVehicles();

    let ymmRestoreGeneration = 0;

    window.restoreGarageDropdownsFromSession = function restoreGarageDropdownsFromSession() {
      const year  = session.get("user_year");
      const make  = session.get("user_make");
      const model = session.get("user_model");
      const trim  = session.get("user_trim") || "";
      if (!year || !make || !model || !dom.yearInput) return;

      const generation = ++ymmRestoreGeneration;
      const isStale = () => generation !== ymmRestoreGeneration;
      window.__everseatsYmmEditRestore = true;

      const clearRestoreFlag = () => {
        if (!isStale()) window.__everseatsYmmEditRestore = false;
      };

      dom.yearInput.value = year;
      dom.yearInput.dispatchEvent(new Event("change", { bubbles: true }));

      window.setTimeout(() => {
        if (isStale() || !dom.makeInput) {
          clearRestoreFlag();
          return;
        }
        dom.makeInput.value = make;
        dom.makeInput.dispatchEvent(new Event("change", { bubbles: true }));

        window.setTimeout(() => {
          if (isStale() || !dom.modelInput) {
            clearRestoreFlag();
            return;
          }
          dom.modelInput.value = model;
          dom.modelInput.dispatchEvent(new Event("change", { bubbles: true }));

          const restoreTrim = () => {
            if (isStale()) {
              clearRestoreFlag();
              return;
            }
            if (!trim || !dom.trimInput) {
              clearRestoreFlag();
              return;
            }
            if (getYmmSelectionMode() === "ekr-only") {
              const entry = getMergedModels(year, make)[model];
              if (entry && !isVehicleLeaf(entry)) {
                resetDropdown(dom.trimInput, "Select Trim");
                Object.keys(entry).sort().forEach((t) => {
                  const opt = document.createElement("option");
                  opt.value = t;
                  opt.innerHTML = t;
                  dom.trimInput.appendChild(opt);
                });
                dom.trimContainer.style.display = "";
                dom.trimInput.removeAttribute("disabled");
              }
            } else if (session.get("user_ekr_fallback") === "1") {
              const entry = getRawMergedModels(year, make)[model];
              const ekrTrims = getEkrTrims(entry || {});
              if (ekrTrims.length > 1) {
                window.__everseatsEkrFallback = true;
                resetDropdown(dom.trimInput, "Select Trim");
                ekrTrims.sort().forEach((t) => {
                  const opt = document.createElement("option");
                  opt.value = t;
                  opt.innerHTML = t;
                  dom.trimInput.appendChild(opt);
                });
                dom.trimContainer.style.display = "";
                dom.trimInput.removeAttribute("disabled");
              }
            } else if (isScsOnlyGarageContext()) {
              const entry = getRawMergedModels(year, make)[model];
              const ekrTrims = getEkrTrims(entry || {});
              if (trim && ekrTrims.includes(trim) && ekrTrims.length > 1) {
                window.__everseatsEkrFallback = true;
                resetDropdown(dom.trimInput, "Select Trim");
                ekrTrims.sort().forEach((t) => {
                  const opt = document.createElement("option");
                  opt.value = t;
                  opt.innerHTML = t;
                  dom.trimInput.appendChild(opt);
                });
                dom.trimContainer.style.display = "";
                dom.trimInput.removeAttribute("disabled");
              }
            }
            dom.trimInput.value = trim;
            dom.trimInput.dispatchEvent(new Event("change", { bubbles: true }));
            clearRestoreFlag();
          };

          if (trim && dom.trimInput) {
            window.setTimeout(restoreTrim, 300);
          } else {
            clearRestoreFlag();
          }
        }, 300);
      }, 300);
    };

    window.everseatsHasValidCustomSeatCoversYmmt = function everseatsHasValidCustomSeatCoversYmmt() {
      const year = session.get("user_year");
      const make = session.get("user_make");
      const model = session.get("user_model");
      const trim = session.get("user_trim") || "";
      if (!year || !make || !model || !trim) return false;
      return vehicleExistsInActiveModel(year, make, model, trim);
    };

    function maybePrefillCustomSeatCoversPicker() {
      if (!isCustomSeatCoversProductPage()) return;
      if (everseatsHasYmmSelected()) return;
      const year = session.get("user_year");
      const make = session.get("user_make");
      const model = session.get("user_model");
      if (!year || !make || !model) return;
      window.restoreGarageDropdownsFromSession();
    }

    maybePrefillCustomSeatCoversPicker();

    if (typeof window.applyEverseatsYmmProductChrome === "function") {
      window.applyEverseatsYmmProductChrome();
    }
    applyEverseatsVariantPickerGate();
    const modeLabel = getYmmSelectionMode();
    const mfrLabel = getManufacturerFilter() ? ` (${getManufacturerFilter()} only)` : "";
    console.log("SeatSearch initialised ✓", Object.keys(activeModel).length, `years loaded`, modeLabel + mfrLabel);
  };

  window.SeatSearch = SeatSearch;

  // Run each setup in isolation so one throwing fn (e.g. missing element) can't
  // abort the rest of the chain. SeatSearch MUST always get a chance to run on
  // every template that has the YMM filter (product, page templates, etc.).
  function safeRun(label, fn) {
    try {
      fn();
    } catch (err) {
      console.error(`[custom.js] ${label} failed:`, err);
    }
  }

  function bootCustomJs() {
    safeRun("applyEverseatsVariantPickerGate", applyEverseatsVariantPickerGate);
    safeRun("featuredslider",     featuredslider);
    safeRun("featuredinfoslider", featuredinfoslider);
    safeRun("trustpolioslider",   trustpolioslider);
    safeRun("instac",             instac);
    safeRun("stickyAddtoCart",    stickyAddtoCart);
    safeRun("SeatSearch",         SeatSearch);
    safeRun("applyEverseatsVariantPickerGate", applyEverseatsVariantPickerGate);
    safeRun("collectionSwatch",   collectionSwatch);
    safeRun("variantBestValue",   variantBestValue);
  }

  // All calls are inside $(window).on("load") so window.model (external <script src=...>)
  // is fully loaded before SeatSearch runs.
  document.addEventListener("DOMContentLoaded", applyEverseatsVariantPickerGate);
  $(window).on("load", bootCustomJs);
  $(document).on("shopify:section:load", bootCustomJs);

})();

document.addEventListener("DOMContentLoaded", function () {});

document.addEventListener("click", function (e) {
  console.log(e.target, "clicked");
});

// ── Restore dropdowns on homepage from sessionStorage ─────────────────────
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    if (location.pathname !== "/") return;

    const year  = sessionStorage.getItem("user_year");
    const make  = sessionStorage.getItem("user_make");
    const model = sessionStorage.getItem("user_model");
    const trim = sessionStorage.getItem("user_trim");
    if (!year || !make || !model) return;

    const needsTrimRestore = sessionStorage.getItem("user_ekr_fallback") === "1" && trim;

    const yearSel = document.querySelector("#year-input-container select");
    if (!yearSel) return;
    yearSel.value = year;
    yearSel.dispatchEvent(new Event("change", { bubbles: true }));

    setTimeout(() => {
      const makeSel = document.querySelector("#make-input-container select");
      if (!makeSel) return;
      makeSel.value = make;
      makeSel.dispatchEvent(new Event("change", { bubbles: true }));

      setTimeout(() => {
        const modelSel = document.querySelector("#model-input-container select");
        if (!modelSel) return;
        modelSel.value = model;
        modelSel.dispatchEvent(new Event("change", { bubbles: true }));

        if (needsTrimRestore) {
          setTimeout(() => {
            const trimSel = document.querySelector("#trim-input-container select");
            if (!trimSel) return;
            trimSel.value = trim;
            trimSel.dispatchEvent(new Event("change", { bubbles: true }));
          }, 300);
        }
      }, 300);
    }, 300);
  }, 1000);
});
